// helpers
import { getUrl, ROUTES } from 'shared/api/urls';
import NFA from 'shared/helpers/analytics/NFAnalytics';
import { ApiHelper } from 'shared/helpers/api';
import { log } from 'shared/helpers/newRelic';
import { TAG_IDENTIFIER } from 'shared/helpers/newRelic/constants';

const MODULE_IDENTIFIER = 'My Profile';

export const generateOtp = (email: string) => {
  const body = { customer_email: email };
  return ApiHelper(getUrl(ROUTES.GENERATE_OTP), {
    method: 'POST',
    body,
    isBodyJSON: true,
  }).then((data: Response) => {
    if (data.status !== 200) {
      return Promise.reject(data.statusText);
    }
    return data.json();
  });
};

export const getProfileData = () => {
  const baseUrl = getUrl(ROUTES.GET_MY_PROFILE);
  const url = `${baseUrl}`;

  return ApiHelper(`${url}`).then((response: Response) => {
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response.json();
  });
};

export const getProfileImage = (imageId?: string) => {
  const baseUrl = getUrl(ROUTES.GET_PROFILE_IMAGE);
  const url = `${baseUrl}?id=${imageId}`;

  return ApiHelper(`${url}`)
    .then((response: Response) => {
      if (!response.ok) {
        return Promise.reject(response);
      }

      return response.json();
    })
    .then((res) => {
      return res.response.image_data;
    })
    .catch((error) => {
      log({
        errTitle: 'Error in getting profile img',
        error,
        tags: { [TAG_IDENTIFIER.MODULE]: MODULE_IDENTIFIER },
      });
    });
};

export const saveProfileData = (profileData) => {
  const baseUrl = getUrl(ROUTES.SAVE_MY_PROFILE);

  const url = `${baseUrl}`;

  let dob = new Date(profileData.dob).toLocaleDateString('en-GB');
  const body = { dob, gender: profileData.gender, name: profileData.name };

  return ApiHelper(`${url}`, { method: 'POST', body, isBodyJSON: true }).then(
    (response: Response) => {
      if (!response.ok) {
        return Promise.reject(response);
      }
      return response.json();
    }
  );
};

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Other', value: 'other' },
];

export const getImageFormat = (image: string) => {
  return image.includes('.svg') ? 'image/svg+xml' : 'image/jpeg';
};

export const onPageLoad = () => {
  NFA.firePageView();
};

export const getMaxDate = () => {
  const todayDate = new Date();

  const currFullYear = todayDate.getFullYear();
  const currMonth = String(todayDate.getMonth() + 1).padStart(2, '0');
  const currDate = String(todayDate.getDate()).padStart(2, '0');

  const maxDate = `${currFullYear}-${currMonth}-${currDate}`;
  return maxDate;
};
